import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import { generateSurveyLink } from '../../utils/helper';
import './Header.scss';

class Header extends Component {
  handleSurveyLinkClick = () => {
    this.props.actions.initiateCustomerSurvey();
  };

  render() {
    const { actions, user, customer } = this.props;
    const { customerDetails, location: { data: { cityName } = {} }, surveyInitiated } = customer;
    const { userEmail } = user.data;
    const selectedPincode = customer && customer.selectedPincode;
    const supplierCityName = customer && customer.cityAttributes && customer.cityAttributes.supplierCityName;
    return (
      <div className="HeaderContainer">
        <div className="OrderOnCall">ORDER ON CALL
        </div>
        {customerDetails && customerDetails.data && customerDetails.data.profile && customerDetails.data.profile.mobileNumber ?
          <div className="UserContainer">Ph No.: {customerDetails.data.profile.mobileNumber}</div> : <div></div>}
        {selectedPincode ? (<div className="pincodeSurveyContainer">
            {!surveyInitiated && <a target="_blank" href={generateSurveyLink(user, customer)} onClick={this.handleSurveyLinkClick} className="surveyLink">Take customer survey</a>}
            <div className="UserContainer">Pincode: {selectedPincode} {cityName ? `(${cityName})` : ''}  Supplier City: {supplierCityName ? `${supplierCityName}` : ''}</div>
          </div>) : <div></div>
        }
        <div className="UserContainer">
          <span>Agent: {userEmail},&nbsp;</span>
          <span role="button" tabIndex={-10} className="LogoutButton" onClick={() => {confirm('Are you sure you want to logout ?') && actions.logoutAgent()}} >
            Logout
          </span>
        </div>
      </div>
    );
  }
};

export default connect(state => ({
  customer: state.customer,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(Header);
